import React from 'react'
import { Box } from '@material-ui/core'
import { ImagesSection } from 'web/src/app/root/components/common/images-uploader'
import { useStyles } from './styles'
import { DeviceStatus } from 'web/src/app/root/components/common'

export const DeviceImages = ({
    imagesForUpload,
    setImagesForUpload,
    setDeletedPictureKeys,
    deletedPictureKeys,
    submitUploadImages,
    loading,
    device,
    permissions,
    getImagesByDeviceId
}) => {
    const classes = useStyles()

    return (
        <Box className={classes.deviceImagesWrapper}>
            <ImagesSection
                imagesForUpload={imagesForUpload}
                setImagesForUpload={setImagesForUpload}
                setDeletedPictureKeys={setDeletedPictureKeys}
                deletedPictureKeys={deletedPictureKeys}
                kind="avatar"
                submitUploadImages={submitUploadImages}
                loading={loading}
                permissions={permissions}
                getImagesByDeviceId={getImagesByDeviceId}
            />
            <Box className={classes.reportStatusWrapper}>
                <DeviceStatus value={device.last_report_type} iconSize={1.3} />
            </Box>
        </Box>
    )
}
